export const referredInitialValues = {
  referral_date: null,
  referred_to_state: null,
  referred_to_district: null,
  referred_to_dccc: null,
  referred_to_dcc_name: null,

  chemo_drug_name: null,
  chemo_drug_dosage: null,
  final_calculated_chemo_drug_dosage: null,
  route_of_drug_administration: null,
  planned_chemo_cycles: null,
  chemo_infusion_rate_duration: null,
  chemo_diluent_volume: null,
  chemo_timing: null,
  chemo_delivery_method: null,
  chemo_notes_special_instructions: null,

  chemp_premedication_drug_name: null,
  chemo_drug_dose: null,
  chemo_administration_route: null,

  // Arrays
  drug_details: [
    {
      drug_name: null,
      dosage: null,
      final_dose: null,
      route_admin: null,
    },
  ],
  premedication_details: [
    {
      drug_name: null,
      drug_dose: null,
      administration_route: null,
    },
  ],

  pre_chemo_hydration_fluid_type: null,
  pre_chemo_hydration_fluid_volume: null,
  pre_chemo_hydration_fluid_duration: null,

  post_chemo_hydration_fluid_type: null,
  post_chemo_hydration_fluid_volume: null,
  post_chemo_hydration_fluid_duration: null,

};

// Map GET response to form values (safe)
export const mapReferredResponse = (data) => {
  if (!data) return referredInitialValues;

  const safeDate = (d) => (d ? (d.slice ? d.slice(0, 10) : d) : "");

  // sort arrays by id ascending
  const drugDetails = Array.isArray(data?.drug_details)
    ? [...data.drug_details]
      .sort((a, b) => (a.drug_id || 0) - (b.drug_id || 0))
      .map((d) => ({
        drug_name: d.drug_name || null,
        dosage: d.dosage || null,
        final_dose: d.final_dose || null,
        route_admin: d.route_admin || null,
      }))
    : [{ drug_name: null, dosage: null, final_dose: null, route_admin: "" }];

  const premedDetails = Array.isArray(data?.premedication_details)
    ? [...data.premedication_details]
      .sort((a, b) => (a.premedication_id || 0) - (b.premedication_id || 0))
      .map((p) => ({
        drug_name: p.drug_name || null,
        drug_dose: p.drug_dose || null,
        administration_route: p.administration_route || null,
      }))
    : [{ drug_name: null, drug_dose: null, administration_route: "" }];

  return {
    referral_date: safeDate(data?.referral_date),
    referred_to_state: data?.referred_to_state ?? null,
    referred_to_district: data?.referred_to_district ?? null,
    referred_to_dccc: data?.referred_to_dccc ?? null,
    referred_to_dcc_name: data?.referred_to_dcc_name || null,

    // chemo_drug_name: data?.chemo_drug_name || null,
    // chemo_drug_dosage: data?.chemo_drug_dosage || null,
    // final_calculated_chemo_drug_dosage: data?.final_calculated_chemo_drug_dosage || null,
    // route_of_drug_administration: data?.route_of_drug_administration || null,
    planned_chemo_cycles: data?.planned_chemo_cycles ?? null,
    chemo_infusion_rate_duration: data?.chemo_infusion_rate_duration ?? null,
    chemo_diluent_volume: data?.chemo_diluent_volume ?? null,
    chemo_timing: data?.chemo_timing ?? null,
    chemo_delivery_method: data?.chemo_delivery_method || null,
    chemo_notes_special_instructions: data?.chemo_notes_special_instructions || null,

    chemp_premedication_drug_name: data?.chemp_premedication_drug_name || null,
    chemo_drug_dose: data?.chemo_drug_dose ?? null,
    chemo_administration_route: data?.chemo_administration_route || null,

    drug_details: drugDetails,
    premedication_details: premedDetails,

    pre_chemo_hydration_fluid_type: data?.pre_chemo_hydration_fluid_type || null,
    pre_chemo_hydration_fluid_volume: data?.pre_chemo_hydration_fluid_volume || null,
    pre_chemo_hydration_fluid_duration: data?.pre_chemo_hydration_fluid_duration || null,

    post_chemo_hydration_fluid_type: data?.post_chemo_hydration_fluid_type || null,
    post_chemo_hydration_fluid_volume: data?.post_chemo_hydration_fluid_volume || null,
    post_chemo_hydration_fluid_duration: data?.post_chemo_hydration_fluid_duration || null,
  };
};
